import type { HTMLProps, LegacyRef } from 'react';
import { forwardRef } from 'react';

// type Error = 
export type ErrorStatus =
    | { tag: "Submited", errors: string[] }
    | { tag: "Not submitted" }

/**
 * Component props.
 */
export interface TextInputProps extends Omit<HTMLProps<HTMLInputElement>, 'onChange'> {
    defaultValue?: string | number;
    onChange: (value: string) => void;
    label: string;
    name: string;
    placeholder: string;
    errors: ErrorStatus;
    required?: boolean;
}

function TextInputComponent({ onChange, defaultValue, label, name, placeholder, children, errors, required, ...props }: TextInputProps, ref: LegacyRef<HTMLDivElement> | undefined) {

    const isSubmited = errors.tag === "Submited";
    const errorList = isSubmited ? errors.errors : [];

    const className =
        isSubmited && errorList.length > 0 ? "form-danger" :
            isSubmited ? "form-success" :
                "";

    return (
        <div ref={ref} className={`input-box ${className || ''} uk-margin`}>
            <label className="uk-form-label" htmlFor={name}>{label} {required && <span style={{ color: 'red' }}>*</span>} </label>
            <input
                type="text"
                placeholder={placeholder}
                {...props}
                className={`uk-input ${className}`}
                defaultValue={defaultValue}
                onChange={(e) => onChange(e.target.value)}
            />
            {children}
            {isSubmited && errorList.length > 0 &&
                (<div style={{fontSize:"13px"}}>
                    {errorList.map(err =>
                    <p style={{ color: 'red', margin: '0', marginTop: '5px' }} className="form-danger warning">
                        <span uk-icon="icon: warning; ratio: 0.8"></span> {err}
                    </p>
                      
                    )}
                </div>)}
        </div>
    );
}

export default forwardRef(TextInputComponent);
